import axios from 'axios';
import { types } from "../types/types";
import { crearErrorAction } from "./ui";

const peticioApi = axios.create({
    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json' },
    withCredentials: true,
    baseURL: process.env.REACT_APP_DOMINI_API_PORTALCOMB
});

// ─── Comprova si l'usuari ha acceptat les condicions ────────────────────────
export const comprovarAcceptacioAction = (idElement,idDocument = null) => {
    return async (dispatch) => {
        try {
            var formBody = `idElement=${encodeURIComponent(idElement)}`;
             if (idDocument) formBody += `&idDocument=${encodeURIComponent(idDocument)}`;
            const response = await peticioApi.post(`/legal/haAcceptat`, formBody);
            const data = response.data;
            if (data.ok) {
                dispatch(legalHaAcceptatAction(data.contingut));
            } else {
                dispatch(legalErrorAction()); // evitem quedar-nos en null infinit
            }
        } catch (error) {
            console.error('Error comprovant acceptació:', error);
            dispatch(legalErrorAction());
        }
    }
}

// ─── Guarda l'acceptació de les condicions ───────────────────────────────────
export const guardarAcceptacioAction = (idElement,idDocument = null) => {
    return async (dispatch) => {
        try {
            var formBody = `idElement=${encodeURIComponent(idElement)}`;
            if (idDocument) formBody += `&idDocument=${encodeURIComponent(idDocument)}`;
            const response = await peticioApi.post(`/legal/acceptar`, formBody);
            const data = response.data;

            if (data.ok) {
                dispatch(legalAcceptarAction());
            } else {
                dispatch(legalErrorAction());
            }
        } catch (error) {
            console.error('Error guardant acceptació:', error);
            dispatch(legalErrorAction());
        }
    }
}
export const carregarDocumentAction = (idDocument = null) => {
    return async (dispatch) => {
        try {
            const url = idDocument ? `/legal/document?idDocument=${idDocument}` : `/legal/document`;
            const response = await peticioApi.get(url);
            const data = response.data;

            if (data.ok) {
                dispatch(legalDocumentVigentAction(data.contingut));
            } else {
                dispatch(legalErrorAction());
            }
        } catch (error) {
            console.error('Error carregant document legal:', error);
            dispatch(legalErrorAction());
        }
    }
}

export const legalDocumentVigentAction = (document) => ({
    type: types.legalDocumentVigent,
    contingut: document
});

// ─── Action Creators ─────────────────────────────────────────────────────────
export const legalHaAcceptatAction = (haAcceptat) => ({
    type: types.legalHaAcceptat,
    contingut: haAcceptat
});

export const legalAcceptarAction = () => ({
    type: types.legalAcceptar
});
export const legalResetAction = () => ({
    type: types.legalReset
});
export const legalErrorAction = () => ({
    type: types.legalError
});